module.exports = __webpack_public_path__ + "img/logo-circle-white.7a94c934.png";